import { DomainCompetency } from "../src/stores/courseStore";

/**
 * Finds all items at the same level in the hierarchy as the target item,
 * regardless of their parent. This is useful for finding all items at a specific
 * level in the tree, not just direct siblings.
 *
 * @param root The root array of DomainCompetency items
 * @param target The target item to find siblings for
 * @returns An array of DomainCompetency items at the same level as the target
 */
export function getAllItemsAtSameLevel(
    root: DomainCompetency[],
    target: DomainCompetency
): DomainCompetency[] {
    const targetLevel = target.standard_level;
    const result: DomainCompetency[] = [];

    function traverse(nodes: DomainCompetency[]): void {
        for (const node of nodes) {
            if (node.standard_level === targetLevel) {
                result.push(node);
            }

            // Recursively traverse children
            if (node.children && node.children.length > 0) {
                traverse(node.children);
            }
        }
    }

    traverse(root);
    return result;
}